/**
 * Workspace reads that belong to no other service (spec #44 §5).
 *
 * Today that is tool ownership (#46 §1): the "Owns" chips on the effect
 * rail, including the rows where `permitted` is false — ownership records
 * a routing fact and grants nothing, so "owned, cannot act yet" is a state
 * the UI must be able to say out loud.
 *
 * Ask (the DM composer, §2) deliberately does NOT get a wrapper here: it
 * is `marketingSuiteApi.ask`, the same pipeline the Ask page uses, and a
 * second seam over it would be a second thing to keep honest.
 */

import { createHeaders } from './apiClient';
import { handleResponse } from './httpResponse';
import type { OwnershipResponse } from '../types/agentMind';

const API_BASE_URL = import.meta.env.VITE_API_URL || '';

/** Every tool ownership row for the tenant. */
export async function getOwnership(): Promise<OwnershipResponse> {
  const response = await fetch(`${API_BASE_URL}/api/agents/ownership`, {
    method: 'GET',
    headers: createHeaders(),
  });
  return handleResponse<OwnershipResponse>(response);
}

/** One agent's ownership rows — what the effect rail pins. */
export async function getAgentOwnership(
  domain: string
): Promise<OwnershipResponse> {
  const response = await fetch(
    `${API_BASE_URL}/api/agents/${encodeURIComponent(domain)}/ownership`,
    { method: 'GET', headers: createHeaders() }
  );
  return handleResponse<OwnershipResponse>(response);
}
